import styled from 'styled-components';

const SummaryTableWrapper = styled.div`
  overflow: auto;
  margin-top: 10px;
  height: calc(100% - 80px);
  table {
    text-align: left;
    border-collapse: separate;
  }
  thead th {
    background: #f5f5fd;
    padding: 8px 10px;
    position: sticky;
    top: 0;
    z-index: 1;
    border-top: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;
  }
  table th:first-child,
  table td:first-child,
  table td[rowspan] + td {
    border-left: 1px solid #d8d8d8;
  }
  table th:last-child,
  table td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  tbody {
    border: 1px solid #d8d8d8;
  }
  tbody [rowspan],
  tbody [rowspan] ~ th,
  tbody [rowspan] ~ td,
  tfoot {
    border-top: 1px solid #d8d8d8;
  }
  tbody tr:last-child td {
    border-bottom: 1px solid #d8d8d8;
  }
  tfoot tr td {
    border-bottom: 1px solid #d8d8d8;
  }
  td {
    vertical-align: baseline;
  }
`;

export { SummaryTableWrapper };
